import { productPropTypes, productsArrayPropTypes } from './lib/products';
import { restaurantPropTypes, restaurantsArrayPropTypes } from './lib/restaurants';
import { selectedLocationPropTypes } from './lib/location';

export {
  productPropTypes,
  productsArrayPropTypes,
  restaurantPropTypes,
  restaurantsArrayPropTypes,
  selectedLocationPropTypes,
};
